/*
 * @Description: 
 * @Author: houcw
 * @Date: 2023-06-11 11:16:43
 * @LastEditTime: 2025-02-13 12:24:03
 * @LastEditors: Please set LastEditors
 * @Reference: 
 */

import base from './index'
let axios = base.axios
let baseURL = base.baseUrl

// 查询会话列表 /vm-ai/chat-session/list{?userKey}

export const getList = params => {
  return axios({
    method: 'get',
    url: `${baseURL}/chat-session/list`,
    params: params
  }).then(res => res.data)
}

// 创建新会话
export const createChat = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/chat-session/`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(res => res.data)
}

// 删除会话
export const deleteChat = params => {
  return axios({
    method: 'delete',
    url: `${baseURL}/chat-session/` + params.id
  }).then(res => res.data)
}


// 清空会话消息
export const clearAll = params => {
  return axios({
    method: 'delete',
    url: `${baseURL}/chat-session/message-store/clear/` + params.id
  }).then(res => res.data)
}
//查询会话消息记录分页列表
export const getHisPage = params => {
  return axios({
    method: "get",
    url: `${baseURL}/chat-session/message-store/page`,
    params: params,
  }).then(res => res.data)
}

//  ai消息点赞 取消点赞
export const isLiked = params => {
  return axios({
    method: "put",
    url: `${baseURL}/chat-session/message-store/liked/` + params.id + '/' + params.liked,
  }).then(res => res.data)
}


//编辑会话 /vm-ai/chat-session/{id}
export const putChatName = params => {
  return axios({
    method: 'put',
    url: `${baseURL}/chat-session/` + params.id,
    data: params
  }).then(res => res.data)
}


// 获取聊天信息
export const chatgpt = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/chat/process`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(res => res.data)
}

// 发送医学影像
export const chatImagetext = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/chat/img_explain_4o`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  }).then(res => res.data)
}

//查询数据库 /chat-db
export const chatDb = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/chat/db`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(res => res.data)
}



// 查询工具
export const chatTool = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/chat/tool`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(res => res.data)
}

// 上传知识库
// /add_knowledge
export const addKnowledge = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/add_knowledge`,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  }).then(res => res.data)

}

// 注册
export const userRegsiter = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/user/reg`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(res => res.data)
}


// 登录
export const loginFun = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/user/login`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(res => res.data)
}

// 风险评估回答
export const guidanceAnswer = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/chat/risk-assessment?direction=${params.direction}`,
    data: params.data,
  }).then(res => res.data)
}
// 健康方案制定
export const healthProgramme = params => {
  return axios({
    method: 'post',
    url: `${baseURL}/chat/health-programme`,
    data: params,
  }).then(res => res.data)
}
